import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, take } from 'rxjs';

import { PROFILE_API } from '../apis/profile.api';
import { ProfileActions } from './profile.actions';

function toErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  try {
    return JSON.stringify(err);
  } catch {
    return 'Unknown error';
  }
}

@Injectable()
export class ProfileEffects {
  private readonly actions$ = inject(Actions);
  private readonly profileApi = inject(PROFILE_API);

  // Snapshot load (kein dauerhafter Listener)
  loadProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileActions.loadProfileRequested),
      switchMap(({ uid }) =>
        this.profileApi.loadProfile(uid).pipe(
          take(1),
          map((profile) => ProfileActions.loadProfileSucceeded({ profile })),
          catchError((err) => of(ProfileActions.loadProfileFailed({ error: toErrorMessage(err) })))
        )
      )
    )
  );

  updateProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileActions.updateProfileRequested),
      switchMap(({ uid, patch }) =>
        this.profileApi.updateProfile(uid, patch).pipe(
          map(() => ProfileActions.updateProfileSucceeded({ patch })),
          catchError((err) => of(ProfileActions.updateProfileFailed({ error: toErrorMessage(err) })))
        )
      )
    )
  );
}
